import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import FilterCarSeat from '../../../components/organism/FilterMenu/CarSeat';
import FilterColor from '../../../components/organism/FilterMenu/Color';
import FilterFuelType from '../../../components/organism/FilterMenu/FuelType';
import FilterPriceRange from '../../../components/organism/FilterMenu/PriceRange';
import FilterPromo from '../../../components/organism/FilterMenu/Promo';
import FilterTransmision from '../../../components/organism/FilterMenu/Transmision';

export default function generateFilterNewCar(
  colorList,
  fuelList,
  transmisionList,
  seatList,
  minPrice,
  maxPrice,
  promotionList,
  slideMin,
  slideMax,
  feature = null,
  impressionData?: {
    customerNo?: string;
    title?: string;
    carCategory?: string;
    carModel?: string;
    sectionName?: string;
    filterValue?: {
      price?: string;
      search?: string;
      color?: string;
      fuel_type?: string;
      transmission?: string;
      capacity?: string;
      tag?: string;
      order_by?: string;
    };
  },
  breadcrumbItems?: IBreadcrumbs[]
) {
  const dataFilter = [
    {
      title: 'Kisaran Harga',
      content: (
        <FilterPriceRange
          minPrice={minPrice}
          maxPrice={maxPrice}
          slideMin={slideMin}
          slideMax={slideMax}
          feature={feature}
          impressionData={impressionData}
          breadcrumbItems={breadcrumbItems}
        />
      ),
      dataTestId: null,
    },
    {
      title: colorList?.name || 'Warna',
      content: colorList?.values?.length ? (
        <FilterColor
          colorList={colorList?.values || []}
          impressionData={impressionData}
          breadcrumbItems={breadcrumbItems}
        />
      ) : null,
      dataTestId: 'color-ncp',
    },
    {
      title: fuelList?.name || 'Tipe Bensin',
      content: fuelList?.values?.length ? (
        <FilterFuelType
          fuelList={fuelList?.values || []}
          impressionData={impressionData}
          breadcrumbItems={breadcrumbItems}
        />
      ) : null,
      dataTestId: 'fuel-type-ncp',
    },
    {
      title: transmisionList?.name || 'Transmisi',
      content: transmisionList?.values?.length ? (
        <FilterTransmision
          transmisionList={transmisionList?.values || []}
          impressionData={impressionData}
          breadcrumbItems={breadcrumbItems}
        />
      ) : null,
      dataTestId: 'transmission-ncp',
    },
    {
      title: seatList?.name || 'Jumlah Kursi',
      content: seatList?.values?.length ? (
        <FilterCarSeat
          seatList={seatList?.values || []}
          impressionData={impressionData}
          breadcrumbItems={breadcrumbItems}
        />
      ) : null,
      dataTestId: 'number-of-seats-ncp',
    },

    {
      title: promotionList?.name || 'Tag',
      content: promotionList?.values?.length ? (
        <FilterPromo
          promotionList={promotionList?.values || []}
          impressionData={impressionData}
          breadcrumbItems={breadcrumbItems}
        />
      ) : null,
      dataTestId: 'promotion-ncp',
    },
  ];

  return dataFilter;
}
